var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChimney = function SvgChimney(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 12.3 14.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M1.831 14.139V8.6h8.615v5.539M11.677 5.523H.6V8.6h11.077zM7.37 8.6v5.539M7.985 8.6V5.523M5.646 3.062c0-1.231.985-1.231.985-2.462M2.57 3.062c0-1.231.984-1.231.984-2.462M8.723 3.062c0-1.231.985-1.231.985-2.462"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChimney);
export default ForwardRef;